import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { WelcomeOnboardingWrapper } from './components/WelcomeOnboardingWrapper';
import { AuthProvider } from './providers/AuthProvider';
import { I18nProvider } from './providers/I18nProvider';
import { QueryProvider } from './providers/QueryProvider';
import { AppRouter } from './router';

/**
 * Root application component.
 * Wraps the app in providers: Auth → Query → I18n → Router.
 */
function App(): React.JSX.Element {
  return (
    <AuthProvider>
      <QueryProvider>
        <I18nProvider>
          <BrowserRouter>
            <AppRouter />
            <WelcomeOnboardingWrapper />
          </BrowserRouter>
        </I18nProvider>
      </QueryProvider>
    </AuthProvider>
  );
}

export default App;
